// NOTE on FSD violation:
// Importing user types here of course violates FSD
//
// to organize thing correctly "persistence/" should be in "root/"
//
// This would be in line with general logic of FSD - if something
// is global and used in all layers it can be only in 2 places - "root/" or "shared/"
// - shared if it's mostly unrelated to any business logic
// - root if it's coupled with business logic
// Access to thing from root is done via Dependency Injection (passing props, context etc.)
//
// While these storage entities are tightly coupled with biometry and authentication
// moving them to root is infeasible.
//
// If in the future FSD violations here start to add-up, necessity to move "persistence/"
// to "root/" will justify time investment
import {LegacyAddressStatus, UserStatusIoTs} from '~/entities/user';
import {ManagedStorage} from './ManagedStorage';

const {defaultCodecs: codecs} = ManagedStorage;

export const UserStatusCodec = codecs.lazy(() => codecs.io(UserStatusIoTs));
export const AddressStatusCodec = codecs.lazy(() => codecs.io(LegacyAddressStatus));
